import { useQuery } from "@tanstack/react-query";
import { fetch3 } from "../commonApis/commonApis";
const url = process.env.REACT_APP_BASE_URL;

export const useFetchVehicleAllData = () => {
    return useQuery({
        queryKey: ["vehicleAllData"], // include country in key
        queryFn: async () => {
            const res = await fetch3(`${url}/api/vehicle/all`, "get");

            if (!res || !res.data) {
                return res.message;
            }

            return res.data;
        },
        // enabled: !!country, // ❗️Don't run until a country is selected
        staleTime: 1000 * 60 * 5,
    });
};


export const useFetchAssignVehicleAllData = (page: number, searchFor: string) => {
    return useQuery({
        queryKey: ["assignVehicleAllData"], // include country in key
        queryFn: async () => {
            const res = await fetch3(`${url}/api/vehicle/assigned?page=${page}&searchFor=${searchFor}`, "get");

            if (!res || !res.data) {
                return res.message;
            }

            return res.data;
        },
        // enabled: !!country, // ❗️Don't run until a country is selected
        staleTime: 1000 * 60 * 5,
    });
};
